import { useEffect, useRef, useState } from "react";

import "antd/dist/antd.css";
import Header from "../../../Sidebar/header";
import Sidebar from "../../../Sidebar/sidebarAdmin";
import { Box, Button, IconButton, Menu, MenuItem, Typography } from "@mui/material";
import { FiUpload } from "react-icons/fi";
import axios from "axios";
import { Table } from "ant-table-extensions";
import { searchData } from "./Constant";
import { itemRender, onShowSizeChange } from "../../../../components/paginationfunction";
import ViewPaySlip from "./ViewPaySlip";
import { useReactToPrint } from "react-to-print";
import { ArrowBack } from "@mui/icons-material";
import styled from "@emotion/styled";
import PaySlipHappycom from "./PaySlipHappycom";
import Swal from "sweetalert2";
import { DatePicker } from "antd";
import moment from "moment";



const SButton = styled(Button)({
  background: "#2DB8C5",
  borderRadius: "4px",
  textTransform: "none",
  boxShadow: "none",
  padding: "8px",
  ":hover": {
    background: "#2DB8C5",
    boxShadow: "none",
  },
});

const ManualPayroll = () => {
  const [menu, setMenu] = useState(false);
  const [showPaySlip, setShowPaySlip] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [manaulData, setManaulData] = useState([]);
  const hiddenFileInput = useRef()

  const open = Boolean(anchorEl);

  const handleClick = (event) => { setAnchorEl(event.currentTarget); };

  const handleClose = () => { setAnchorEl(null); };

  const toggleMobileMenu = () => { setMenu(!menu); };


  const [selectedMonth, setSelectedMonth] = useState(moment());


  // const token = sessionStorage.getItem("access_token");


  const handleExcelDownload = () => {
    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/download-template`, {
        params: {
          coregid: sessionStorage.getItem("coid"),
          toggle: `dev`,
        },
        responseType: "blob", // Set responseType to 'blob'
      })
      .then((res) => {
        const url = window.URL.createObjectURL(
          new Blob([res.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          })
        );
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `manual_template.xlsx`); // Ensure the correct file extension
        link.setAttribute("target", `_blank`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      .catch((err) => {
        console.error("Error downloading the file:", err);
      });
  };

  const readUploadFile = async (e) => {
    const file = e.target.files[0]; // 📌 selected file

    console.log('file', file)

    if (!file) return;

    const formData = new FormData();
    formData.append("file", file); // 📌 key: "file"

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/upload-payslip-data/?file%20=null`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data", // 📌 Important
          },
        }
      );

      console.log("Uploaded Successfully:", res.data);
      if (res?.data?.status === "success") {
        Swal.fire({
          icon: "success",
          text: "File Uploaded Successfully",
        })
      }

    } catch (error) {
      console.error("Upload Error:", error);
    } finally {
      e.target.value = null; // <-- IMPORTANT RESET
    }
  };


  const inputRef = useRef()

  const printPage = useReactToPrint({
    content: () => inputRef.current,
    documentTitle: "downloadpayslip",
  });

  const [userData, setUserData] = useState(null)

  const getEmployeePayslipData = async (employeeId, month, year) => {
    try {
      const response = await axios.get(
        `https://oz.middleware.prod.api.ozhrms.com/get-employee-payslip-data/`,
        {
          params: {
            employee_id: employeeId,
            month: month,
            year: year,
          },
        }
      );

      console.log("Payslip Data:", response.data);
      if(response?.data?.data?.length > 0){
        setUserData(response?.data?.data[0] ||  null)
           setShowPaySlip(true)
      }
      Swal.fire({
        icon: "success",
        text: response?.data?.message || 'Payslip Fetched Successfully',
      })
      return response.data;
    } catch (error) {
      console.error("Error fetching payslip data:", error);
      throw error;
    }
  };

  console.log('employee_name',manaulData)

  const column1 = [
    {
      title: "Employee ID",
      dataIndex: "employee_id",
      sorter: (a, b) => a.emp_id.length - b.emp_id.length,
    },
    {
      title: "Employee Name",
      dataIndex: "employee_name",
      sorter: (a, b) => a.employee_name.toLowerCase().localeCompare(b.employee_name.toLowerCase()),
    },
       {
      title: "Email",
      dataIndex: "email",
    },
       {
      title: "Phone",
      dataIndex: "phone",
    },
       {
      title: "Department",
      dataIndex: "department",
    },
       {
      title: "Designation",
      dataIndex: "designation",
    },
       {
      title: "Date Of Joining",
      dataIndex: "date_of_joining",
    },
    {
      title: "Action",
      align: "center",
      render: (text, record) => (
        <Button onClick={() => {
          const month = selectedMonth.month() + 1; // months are 0 indexed in moment
          const year = selectedMonth.year();
          getEmployeePayslipData(record?.employee_id, month, year)
       
        }} variant="contained" sx={{ textTransform: 'capitalize' }}>
          View Payslip
        </Button>
      ),
    },
  ];

  

  const fetchManualPayroll = async (month, year) => {

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/getallemployeemanualpayslipdata/?comp_id=${sessionStorage.getItem('coid')}&month=${month}&year=${year}`,
       );

      // console.log("Payslip Data:", response.data);
      setManaulData(response?.data?.data)
      Swal.fire({
        icon: "success",
        text: 'Manual Payroll Fetched Successfully',
      })
      return response.data;
    } catch (error) {
      console.error("Error fetching payslip data:", error);
      throw error;
    }
  };

  useEffect(() => {
       const month = selectedMonth.month() + 1; // months are 0 indexed in moment
          const year = selectedMonth.year();
    fetchManualPayroll(month,year)
  }, [selectedMonth])



  return (
    <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
      <Header onMenuClick={(value) => toggleMobileMenu()} />
      <Sidebar />
      <div className="page-wrapper">
        {/* Page Content */}
        <div className="content container-fluid">
          {/* Page Header */}
          <div className="page-header">
            <div className="row align-items-center">
              <div className="col">

                <Box sx={{ display: "flex", flexDirection: 'row', justifyContent: 'space-between' }}>
                  <h3 className="page-title">
                    <span style={{ cursor: "pointer" }}>Manual Payroll</span>
                  </h3>

                  <Box sx={{ display: "flex", flexDirection: 'row', alignItems: 'center', gap: '20px' }}>
                    <div style={{ display: "flex", gap: "10px", }}>

                      <DatePicker
                        picker="month"
                        format="MM/YYYY"
                        value={selectedMonth}
                        onChange={(value) => setSelectedMonth(value)}
                        style={{ width: 180 }}
                        allowClear={false}
                        disabledDate={(current) => current && current > moment().endOf("month")} // optional
                      />



                    </div>
                    <button
                      className=""
                      classname="edit-icon"
                      style={{ display: "flex", alignItems: "center", padding: "19px 23px", height: "30px", fontSize: "15px", background: " #2b8f6f", border: "none", color: "white", borderRadius: "10px", }}
                    >
                      <Box>
                        <IconButton onClick={handleClick} size="small" color="white" aria-controls={open ? "account-menu" : undefined} aria-haspopup="true" aria-expanded={open ? "true" : undefined}  >
                          <p style={{ fontSize: "14px", marginTop: "15px", color: "white", fontWeight: "500", }}><FiUpload />&nbsp;&nbsp; Manual Payroll Template </p>
                        </IconButton>
                      </Box>
                    </button>
                  </Box>
                  <Menu anchorEl={anchorEl} open={open} onClose={handleClose} onClick={handleClose}
                    transformOrigin={{ horizontal: "right", vertical: "top", }}
                    anchorOrigin={{ horizontal: "right", vertical: "bottom", }}  >
                    <MenuItem onClick={() => handleExcelDownload()}>  Download Template</MenuItem>
                    <MenuItem onClick={(e) => hiddenFileInput.current.click()}>   Upload File </MenuItem>
                  </Menu>

                  <input type="file" ref={hiddenFileInput} onChange={(e) => readUploadFile(e)} style={{ display: "none" }}
                    accept=".xls,.xlsx,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" />
                </Box>

                {!showPaySlip ?

                  <div className="card  pre-table" style={{ marginTop: 15 }}>
                    <div className="table-responsive">
                      <Table searchable exportableProps={{ showColumnPicker: true }} className="table-striped"
                        style={{ overflowX: "auto" }} columns={column1} dataSource={manaulData} rowKey={(record) => record.id}
                        pagination={{
                          total: manaulData.length,
                          showTotal: (total, range) =>
                            `Showing ${range[0]} to ${range[1]} of ${total} entries`,
                          showSizeChanger: true,
                          onShowSizeChange: onShowSizeChange,
                          itemRender: itemRender,
                        }}
                      />
                    </div>
                  </div>
                  :
                  <>
                    <Box sx={{ display: "flex", flexWrap: "wrap", justifyContent: "space-between", ml: "auto", mr: "auto", p: 1, }}      >
                      <button className="btn btn-success btn-block "
                        style={{ padding: "4px 6px", fontSize: "15px", background: " #3298DB", border: "none", color: "white", borderRadius: "20px", }} classname="edit-icon" onClick={() => setShowPaySlip(false)}  >
                        <ArrowBack />
                      </button>

                      <SButton onClick={printPage}> <Typography variant="body2" sx={{ color: "#FFFFFF" }}>   Download </Typography>
                      </SButton>
                    </Box>
                    <Box ref={inputRef}>
                      {sessionStorage.getItem("coid") === "LSD 174449" ?
                        <PaySlipHappycom userData={userData} />
                        :
                        <ViewPaySlip userData={userData}  />
                      }
                    </Box>
                  </>
                }
              </div>

            </div>
          </div>


        </div>

      </div>
    </div>
  );
};

export default ManualPayroll;
